<template>
  <v-icon color="green">
    {{ font }} {{ icon }}
  </v-icon>
</template>
<script>
export default {
  props: {
    document: {
      type: Object,
      required: true,
    },
    font: {
      type: String,
      default: 'fal',
    },
  },
  computed: {
    icon() {
      switch (this.document.mime_type) {
        case 'application/pdf':
          return 'fa-file-pdf';
        case 'application/vnd.openxmlformats-officedocument.presentationml.presentation':
        case 'application/vnd.ms-powerpoint':
          return 'fa-file-powerpoint';
        case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
        case 'application/vnd.ms-excel':
          return 'fa-file-excel';
        case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
        case 'application/msword':
          return 'fa-file-word';
        case 'video/mp4': // MLD-3133
        case 'video/mpeg':
        case 'video/quicktime':
        case 'video/x-m4v':
          return 'fa-file-video'
        case 'image/jpeg': // MLD-3133
        case 'image/png':
        case 'image/gif':
        case 'image/tif':
        case 'image/tiff':
          return 'fa-file-image'
        default:
          return 'fa-file';
      }
    }
  }
}
</script>
